import { isBefore, parseISO, format, subDays } from 'date-fns';

// the earliest date the agent can back date the cancellation
// if the agent can back date, then the earliest date is the effective date
// otherwise, the earliest date is 60 days before today
export const getEarliestDateAgentAllowedToBackdateCancellation = (effectiveDate, canBackDatePermission) => {
  const sixtyDaysBeforeToday = format(subDays(new Date(), 61), 'yyyy-MM-dd'); // add 1 to include 60 days ago today
  const is60DaysBeforeTodayBeforeEffectiveDate = isBefore(parseISO(sixtyDaysBeforeToday), parseISO(effectiveDate));

  const effectiveDateFormatted = format(parseISO(effectiveDate), 'yyyy-MM-dd');

  const minDateForCancellation = canBackDatePermission
    ? effectiveDateFormatted
    : is60DaysBeforeTodayBeforeEffectiveDate
      ? effectiveDateFormatted
      : sixtyDaysBeforeToday;

  return minDateForCancellation;
};
